module.exports = __webpack_public_path__ + "static/media/Basal_4420.309d8089.jpg";